var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelDisplayAd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.926 19.973c1.698 0 3.074-3.575 3.074-7.986S18.624 4 16.926 4c-.647 0-1.247.52-1.742 1.407l-.007-.006C12.807 8.83 7.352 9.33 5.053 9.381 4.48 9.396 4 9.858 4 10.43v3.251c0 .58.488 1.044 1.067 1.048q.35.003.784.02l1.201 4.482a1 1 0 0 0 1.225.707l.49-.132a1 1 0 0 0 .708-1.225l-.953-3.556c2.329.394 4.993 1.29 6.522 3.288l.005-.003c.519 1.043 1.17 1.663 1.877 1.663m-.726-3.072c.828 0 1.5-2.166 1.5-4.838s-.672-4.838-1.5-4.838c-.829 0-1.5 2.166-1.5 4.838s.671 4.838 1.5 4.838",
  clipRule: "evenodd"
})));
export default SvgGemChannelDisplayAd;